import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { BuyButton } from './ui/BuyButton';
import { HERO_BADGES, HERO_STATS } from '../data/content';
const PRODUCT_MOCKUP = 'https://cdn.magicpatterns.com/uploads/u4YnCExnvh15QBKqr1Hiu5/Firefly_Gemini_Flash_ponele_un_fondo_acorde_a_la_estetica_y_haccelo_mas_rosa_bebe,_formato_4-5_368228-Photoroom.png';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-sand" data-id="element-129" data-mp="xannrwhepbds">
      <div className="mx-auto flex max-w-4xl flex-col items-center px-5 py-16 text-center sm:py-20 lg:py-24" data-id="element-130" data-mp="xb5w3rhcfg22">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 rounded-full border border-sage/30 bg-cream px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-sage-deep" data-id="element-131" data-mp="sd4bh249r8oh">
          RecursosFitness™ · Sistema completo para instructoras
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="mt-5 max-w-3xl font-serif text-4xl font-semibold leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-id="element-132" data-mp="3o7lshs6gf8ph">
          Todo tu año de clases listo con{' '}
          <span className="italic text-sage-deep" data-id="element-133" data-mp="30hrf99i83i4p">Yoga 360</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12
      }} className="mt-5 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-134" data-mp="3599i633t3ssb">
          <span className="font-semibold text-ink" data-id="element-135" data-mp="2vjpvsngvxgsp">7 Tomos</span> · 60+ clases listas y{' '}
          <span className="font-semibold text-ink" data-id="element-136" data-mp="2hkgj3xrw14th">5 bonos incluidos</span>. Un sistema completo
          para enseñar con claridad, seguridad y profesionalismo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.16,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mt-6 w-full max-w-md sm:mt-8 sm:max-w-lg" data-id="element-137" data-mp="s2b7hx6yyh4m">
          <img src={PRODUCT_MOCKUP} alt="Megapack Yoga Resuelta con tomos, planificador y recursos para instructoras" className="mx-auto w-full object-contain" data-id="element-138" data-mp="ddnfu208urjy" />
        </motion.div>

        <motion.ul initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.24
      }} className="mt-6 flex max-w-3xl flex-wrap justify-center gap-2.5" data-id="element-139" data-mp="16344qponnqbf">
          {HERO_BADGES.map(badge => <li key={badge} className="inline-flex items-center gap-1.5 rounded-full bg-cream px-3.5 py-1.5 text-sm font-medium text-ink shadow-sm" data-id="element-140" data-mp="3ltgo5tkf8wpx">
              <CheckIcon className="h-4 w-4 text-sage" data-id="element-141" data-mp="1x9ks4fme6se1" />
              {badge}
            </li>)}
        </motion.ul>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-9 flex flex-col items-center gap-4" data-id="element-142" data-mp="21bxzf8gseycx">
          <BuyButton data-id="element-143" data-mp="2b20s17jzyaaq">Comprar ahora y empezar hoy</BuyButton>
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-muted" data-id="element-144" data-mp="2g0lpx0bs0hw0">
            <span className="inline-flex items-center gap-1.5" data-id="element-145" data-mp="2ky43j40qnlac">
              <ShieldCheckIcon className="h-4 w-4 text-sage" data-id="element-146" data-mp="2l0qb33nmq0sk" /> Garantía 7 días
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-147" data-mp="2oyo1g9t4ysxj">
              <LockIcon className="h-4 w-4 text-sage" data-id="element-148" data-mp="2tz1xethgqcf7" /> Pago 100% seguro
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-149" data-mp="unrdf55k3zx3">
              <CreditCardIcon className="h-4 w-4 text-sage" data-id="element-150" data-mp="zlauectn2qsq" /> Mercado Pago | Tarjeta
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.38
      }} className="mt-10 w-full max-w-2xl rounded-2xl border border-sage/15 bg-cream/80 px-5 py-4 shadow-lg shadow-sage-deep/5" data-id="element-151" data-mp="4a2xptbp3q3u">
          <div className="grid grid-cols-2 gap-y-4 sm:grid-cols-4" data-id="element-152" data-mp="9bs6t3fcxtpa">
            {HERO_STATS.map(stat => <div key={stat.label} data-id="element-153" data-mp="3hqsgyien6hoq">
                <div className="font-serif text-xl font-semibold text-sage-deep" data-id="element-154" data-mp="3cr7brq8vpd3k">
                  {stat.value}
                </div>
                <div className="mt-0.5 text-xs leading-tight text-muted" data-id="element-155" data-mp="3rh56yq587329">{stat.label}</div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}